import React, { PropsWithChildren } from 'react';
import {
  Card as CardComponent,
  CardBody,
  CardTitle,
  ListGroup,
} from 'reactstrap';
import { ConditionsCardLoading, ConditionsCardNotApplicable } from '.';

const Card = ({
  children,
  loading,
  notApplicable,
}: PropsWithChildren<{ loading?: boolean; notApplicable?: boolean }>) => (
  <CardComponent>
    <CardBody>
      <CardTitle>
        <h4>Conditions</h4>
      </CardTitle>
      {loading ? (
        <ConditionsCardLoading />
      ) : notApplicable ? (
        <ConditionsCardNotApplicable />
      ) : (
        <ListGroup flush>{children}</ListGroup>
      )}
    </CardBody>
  </CardComponent>
);

export default Card;
